export const getters = {
  getChangelogEntries: state => state.records,
  getChangelogUIFlags: state => state.uiFlags,
  getChangelogMeta: state => state.meta,
  getChangelogUnreadCount: state => state.unreadCount,
};
